import React, { ReactNode } from "react";

import "./modal.css";

interface ModalProps {
  open: boolean;
  children: ReactNode;
  className?: string;
  backClass?: string;
  handleClose?: () => void;
}

const Modal: React.FC<ModalProps> = ({
  open,
  children,
  className = "",
  backClass = "!bg-black-100/7 backdrop-blur-sm",
  handleClose,
}) => {
  return (
    <>
      {open && (
        <div
          className={`modalWrapper ${backClass}`}
          onClick={(e) => {
            e.nativeEvent.stopImmediatePropagation();
            handleClose?.();
          }}
        >
          <div
            className={`modalContentWrapper ${className}`}
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
